import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0f8a3a09"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-12" }
const _hoisted_2 = { class: "card-body pt-9 pb-0" }
const _hoisted_3 = { class: "d-flex flex-wrap flex-sm-nowrap mb-3" }
const _hoisted_4 = { class: "me-7 mb-4" }
const _hoisted_5 = { class: "symbol symbol-100px symbol-lg-200px symbol-fixed position-relative" }
const _hoisted_6 = { class: "symbol symbol-200px" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-img overlay-layer" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined text-white" }, " image_search ")
], -1))
const _hoisted_8 = { class: "flex-grow-1" }
const _hoisted_9 = { class: "d-flex justify-content-between align-items-start flex-wrap mb-2" }
const _hoisted_10 = { class: "d-flex flex-column" }
const _hoisted_11 = { class: "d-flex align-items-center mb-2" }
const _hoisted_12 = { class: "text-gray-800 fs-2 fw-bolder me-1" }
const _hoisted_13 = {
  key: 0,
  class: "svg-icon svg-icon-1 svg-icon-success",
  "data-bs-toggle": "tooltip",
  "data-bs-custom-class": "tooltip-dark",
  "data-bs-placement": "top",
  title: "Verified"
}
const _hoisted_14 = { class: "d-flex flex-wrap fw-bold fs-6 mb-4 pe-2" }
const _hoisted_15 = { class: "me-3 text-muted" }
const _hoisted_16 = { class: "svg-icon svg-icon-4 me-3" }
const _hoisted_17 = { class: "me-3 text-muted" }
const _hoisted_18 = { class: "svg-icon svg-icon-4 me-3" }
const _hoisted_19 = { class: "me-3 text-muted" }
const _hoisted_20 = { class: "svg-icon svg-icon-4 me-3" }
const _hoisted_21 = { class: "d-flex flex-wrap" }
const _hoisted_22 = { class: "d-flex flex-column flex-grow-1" }
const _hoisted_23 = { class: "d-flex flex-wrap row gx-9 gy-3" }
const _hoisted_24 = { class: "col-lg-3" }
const _hoisted_25 = { class: "border border-gray-300 border-dashed rounded h-100px d-flex flex-column justify-content-center" }
const _hoisted_26 = { class: "fs-3x fw-bolder text-center" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fw-bold fs-6 text-gray-400 text-center" }, /*#__PURE__*/_toDisplayString('Staffs'), -1))
const _hoisted_28 = { class: "col-lg-3" }
const _hoisted_29 = { class: "border border-gray-300 border-dashed rounded h-100px d-flex flex-column justify-content-center" }
const _hoisted_30 = { class: "fs-3x fw-bolder text-center" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fw-bold fs-6 text-gray-400 text-center" }, /*#__PURE__*/_toDisplayString('Cars Own'), -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "border border-gray-300 border-dashed rounded h-100px d-flex flex-column justify-content-center" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "fs-3x fw-bolder text-center" }, /*#__PURE__*/_toDisplayString('0')),
    /*#__PURE__*/_createElementVNode("div", { class: "fw-bold fs-6 text-gray-400 text-center" }, /*#__PURE__*/_toDisplayString('Cars In Manage'))
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", {
              class: "overlay cursor-pointer",
              "data-bs-toggle": "modal",
              "data-bs-target": "#modal",
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.changeImage(_ctx.partnerStoreData.image || $setup.placeholderImage)))
            }, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", {
                  style: _normalizeStyle(`background-image: url('${
                    _ctx.partnerStoreData.image || $setup.placeholderImage
                  }')`),
                  class: "custom-image-box"
                }, null, 4),
                _hoisted_7
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.partnerStoreData.name || '-'), 1)
                ]),
                (_ctx.partnerStoreData.verifyState === 'Done')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen026.svg" })
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("span", _hoisted_16, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotune/communication/com006.svg" })
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.partnerStoreData.owner?.name || '-'), 1)
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("span", _hoisted_18, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotune/electronics/elc002.svg" })
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.partnerStoreData.phone || '-'), 1)
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("span", _hoisted_20, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotune/communication/com011.svg" })
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.partnerStoreData.email || '-'), 1)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, _toDisplayString($props.staffCount || '0'), 1),
                    _hoisted_27
                  ])
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, _toDisplayString($props.carCount || 0), 1),
                    _hoisted_31
                  ])
                ]),
                _hoisted_32
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}